module.exports = __webpack_public_path__ + "img/bm-sputnik.54ad2bdf.png";